export const middlemileManifest = {
    id: 'middlemile',
    name: 'Middle Mile',
    description: 'Depot-to-depot and warehouse transportation with driver instructions and dock photos',
    version: '1.1.0',
    icon: 'Warehouse',
    dependencies: ['maps', 'payments'],
    compatibleVehicles: ['van_xl', 'luton'],
    allowedRoles: ['customer', 'driver', 'business', 'admin'],
    supportsB2B: true,
    b2bFeatures: {
        multiStop: false,
        routeOptimization: true,
        recurringRoutes: true,
        freightTracking: true,
        palletSupport: true,
    },
    pricing: {
        configurable: true,
        b2bConfigurable: true,
        fields: [
            { key: "vatRate", type: "percentage", label: "VAT Rate", hint: "UK VAT percentage applied to all charges", format: "percent", defaultValue: 0, min: 0, max: 100 },
            { key: 'basePrice', type: 'money', label: 'Base Price', hint: 'Base price for hub-to-hub transport (in pence)', format: 'pence', defaultValue: 8000, required: true },
            { key: 'pricePerMile', type: 'money', label: 'Price per Mile', hint: 'Charge per mile beyond base (in pence)', format: 'pence', defaultValue: 250, required: true },
            { key: 'pricePerPallet', type: 'money', label: 'Price per Pallet', hint: 'Charge per standard pallet (in pence)', format: 'pence', defaultValue: 1500 },
            { key: 'pricePerKg', type: 'money', label: 'Price per Kg', hint: 'Weight-based charge per kilogram (in pence)', format: 'pence', defaultValue: 5 },
            { key: 'minDistance', type: 'number', label: 'Minimum Distance (miles)', hint: 'Shortest trip distance to qualify for this service', format: 'number', defaultValue: 10 },
            { key: 'overnightMultiplier', type: 'percentage', label: 'Overnight Multiplier', hint: 'Price multiplier for overnight transport', format: 'percent', defaultValue: 1.3, min: 1, max: 3 },
        ],
    },
    features: {
        requiresInventory: false,
        requiresPropertyType: false,
        allowsMultiDrop: false,
        requiresFloorInfo: false,
        hasAssemblyOption: false,
    },
};
//# sourceMappingURL=manifest.js.map